import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import { CategoryType } from 'types';
import CargosConstants from 'constants/Cargos';
import SelectControl from 'components/SelectControl';
import InputControl from 'components/InputControl';

import './DimensionsControl.scss';

class DimensionsControl extends Component {

    static propTypes = {
        selectedCategory: PropTypes.instanceOf(CategoryType).isRequired,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);
        var id = uniqueId();
        this._lengthFieldName = `${id}-length`;
        this._widthFieldName = `${id}-width`;
        this._heightFieldName = `${id}-height`;
        this._weightFieldName = `${id}-weight`;
        this._volumeFieldName = `${id}-volume`;
        this._unitsFieldName = `${id}-units`;

        this.state = {
            length: this.props.length || '',
            width: this.props.width || '',
            height: this.props.height || '',
            volume: this.props.volume || '',
            weight: this.props.weight || '',
            unit_of_measurement: this._defineUnits(this.props),
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            length: nextProps.length || '',
            width: nextProps.width || '',
            height: nextProps.height || '',
            volume: nextProps.volume || '',
            weight: nextProps.weight || '',
            unit_of_measurement: this._defineUnits(nextProps),
        });
    }
    
    _defineUnits = (props) => {
        let unitOfMeasurement = null
        if (props.selectedCategory.name === 'loose' || props.selectedCategory.name === 'liquid') {
            unitOfMeasurement = [CargosConstants.UNITS.M]
        } else if (props.unit_of_measurement) {
            unitOfMeasurement = props.unit_of_measurement
        } else {
            unitOfMeasurement = [CargosConstants.UNITS.CM]
        }
        
        return unitOfMeasurement
    }

    _getVolume = () => {
        var attributes = this.props.attributes;

        if (!attributes.length && !attributes.width && !attributes.height) {
            return this.state.volume;
        }

        var volume = ['width', 'height', 'length']
            .map(dimension => parseFloat(this.state[dimension]))
            .reduce((result, value) => result * value || 0, 1);

        if (this._getUnitOfMeasurement() === CargosConstants.UNITS.CM && volume > 0 && volume < 10000) {
            volume = 10000;
        } else if (this._getUnitOfMeasurement() === CargosConstants.UNITS.M && volume > 0 && volume < 0.01) {
            volume = 0.01;
        }

        return volume;
    };

    _transformDimensions = (value) => {

        if (isNaN(parseFloat(value))) {
            return value;
        }

        switch (this.state.unit_of_measurement[0]) {
            case CargosConstants.UNITS.CM:
                value *= 1e2;
                break;
            case CargosConstants.UNITS.M:
                value /= 1e2;
                break;
        }

        return value;
    }

    _transformWeight = (value) => {

        if (isNaN(parseFloat(value))) {
            return value;
        }

        switch (this.state.unit_of_measurement[0]) {
            case CargosConstants.UNITS.CM:
                value *= 1e3;
                break;
            case CargosConstants.UNITS.M:
                value /= 1e3;
                break;
        }

        return value.toFixed(3);
    }

    _transformVolume = (value) => {

        if (isNaN(parseFloat(value))) {
            return value;
        }

        switch (this.state.unit_of_measurement[0]) {
            case CargosConstants.UNITS.CM:
                value *= 1e6;
                break;
            case CargosConstants.UNITS.M:
                value /= 1e6;
                break;
        }

        return value;
    }

    _onValueChange = (name, event, value) => {

        if (event) {
            // If you want to access the event properties in an asynchronous way,
            // you should call event.persist() on the event, which will remove
            // the synthetic event from the pool and allow references
            // to the event to be retained by user code.
            event.persist();
        }

        if (!value) {
            value = event.target.value;
        }

        // Число, возможно дробное, разделитель точка или запятая. Другие символы не пропускаем
        var pattern = /^\d+[,\.]?(\d*)?$/;

        if (pattern.test(value) || !value) {

            if (name !== 'unit_of_measurement') {
                value = value.replace(/,/g, ".");
            }

            this.setState({
                [name]: value
            }, () => {

                if (name === 'unit_of_measurement') {

                    var width = this._transformDimensions(this.state.width);
                    var height = this._transformDimensions(this.state.height);
                    var length = this._transformDimensions(this.state.length);
                    var weight = this._transformWeight(this.state.weight);

                    if (width) {
                        this._onValueChange('width', null, width.toString());
                    }

                    if (height) {
                        this._onValueChange('height', null, height.toString());
                    }

                    if (length) {
                        this._onValueChange('length', null, length.toString());
                    }

                    if (weight) {
                        this._onValueChange('weight', null, weight.toString());
                    }

                    if (!width && !height && !length) {
                        var volume = this._transformVolume(this.state.volume);

                        if (volume) {
                            this._onValueChange('volume', null, volume.toString());
                        }
                    }

                    return;
                }

                const {onChange} = this.props;

                var volume = this._getVolume();
                if (volume >= 0) {
                    this.setState({
                        volume: volume
                    });
                }

                var state = {};
                var width = this.state.width;
                var height = this.state.height;
                var length = this.state.length;
                var weight = this.state.weight;

                if (this.props.attributes.width) state.width = width;
                if (this.props.attributes.height) state.height = height;
                if (this.props.attributes.length) state.length = length;
                if (this.props.attributes.volume && volume >= 0) state.volume = volume;
                if (this.props.attributes.weight) state.weight = weight;
                if (this.props.attributes.unit_of_measurement) state.unit_of_measurement = this.state.unit_of_measurement;

                if (onChange) {
                    onChange(event, state);
                }

            });
        } else {
            return false;
        }
    };

    _getUnitOfMeasurement() {
        return this.state.unit_of_measurement[0];
    }

    render() {
        const {attributes} = this.props;

        const dimensionPlaceholder = (
            this._getUnitOfMeasurement() === CargosConstants.UNITS.CM &&
            this.props.selectedCategory.id != 'liquid' &&
            this.props.selectedCategory.id != 'loose'
        ) ? 'см' : 'м';
        const volumePlaceholder = (
            this._getUnitOfMeasurement() === CargosConstants.UNITS.CM &&
            this.props.selectedCategory.id != 'liquid' &&
            this.props.selectedCategory.id != 'loose'
        ) ? 'кг' : 'т';

        var volume = this._getVolume();

        var unitOfMeasurement = null;
        if (attributes.unit_of_measurement && this.props.selectedCategory.id != 'liquid' && this.props.selectedCategory.id != 'loose') {
            unitOfMeasurement = (
                <div className="DimensionsControl-measure">
                    <SelectControl className="DimensionsControl-select"
                        label="Ед. измерения"
                        labelSize="small"
                        name={this._unitsFieldName}
                        value={this._getUnitOfMeasurement()}
                        onChange={this._onValueChange.bind(this, 'unit_of_measurement')}
                        options={[
                            { value: CargosConstants.UNITS.CM, label: 'см / кг' },
                            { value: CargosConstants.UNITS.M, label: 'м / т' }
                        ]} />
                </div>
            );
        }

        var length = null;
        if (attributes.length) {
            var lengthClass = classNames([
                'DimensionsControl-input',
                { '-error': attributes.length.error }
            ]);
            length = (
                <div className="DimensionsControl-length">
                    <InputControl className={lengthClass}
                        label="Длина"
                        labelSize="small"
                        id={this._lengthFieldName}
                        value={this.state.length}
                        type="text"
                        pattern="(\d+.?\d*)"
                        placeholder={dimensionPlaceholder}
                        onChange={this._onValueChange.bind(this, 'length')} />
                </div>
            );
        }

        var width = null;
        if (attributes.width) {
            var widthClass = classNames([
                'DimensionsControl-input',
                { '-error': attributes.width.error }
            ]);
            width = (
                <div className="DimensionsControl-width">
                    <InputControl className={widthClass}
                        label="Ширина"
                        labelSize="small"
                        id={this._widthFieldName}
                        value={this.state.width}
                        type="text"
                        pattern="(\d+.?\d*)"
                        placeholder={dimensionPlaceholder}
                        onChange={this._onValueChange.bind(this, 'width')} />
                </div>
            );
        }

        var height = null;
        if (attributes.height) {
            var heightClass = classNames([
                'DimensionsControl-input',
                { '-error': attributes.height.error }
            ]);
            height = (
                <div className="DimensionsControl-height">
                    <InputControl className={heightClass}
                        label="Высота"
                        labelSize="small"
                        id={this._heightFieldName}
                        type="text"
                        pattern="(\d+.?\d*)"
                        value={this.state.height}
                        placeholder={dimensionPlaceholder}
                        onChange={this._onValueChange.bind(this, 'height')} />
                </div>
            );
        }

        var dimensions = null;
        if (width || height || length) {
            dimensions = (
                <div className="DimensionsControl-dimensions">
                    {length}
                    {width}
                    {height}
                </div>
            );
        }

        var weight = null;
        if (attributes.weight) {
            var weightClass = classNames([
                'DimensionsControl-input',
                { '-error': attributes.weight.error }
            ]);

            var weightValue = this.state.weight;
            weight = (
                <div className="DimensionsControl-weight">
                    <InputControl className={weightClass}
                        label="Вес"
                        labelSize="small"
                        id={this._weightFieldName}
                        type="text"
                        pattern="(\d+.?\d*)"
                        placeholder={volumePlaceholder}
                        value={weightValue}
                        onChange={this._onValueChange.bind(this, 'weight')} />
                </div>
            );
        }

        var isWhl = (attributes.length || attributes.width || attributes.height);
        var volumeClass = ['DimensionsControl-volume'];
        var volumeControl = null;
        var equally = null;

        if (isWhl) {
            volumeClass.push('DimensionsControl-volume--read_only');
            // Перевод объёма в кубометры только перед отображением
            if (this._getUnitOfMeasurement() === CargosConstants.UNITS.CM) {
                volume /= 1e6;
            }

            equally = <span className="DimensionsControl-equally">=</span>;
            volumeControl = (
                <div className={volumeClass.join(' ')}>
                    <label className="DimensionsControl-label">Объём</label>
                    <input className="DimensionsControl-input"
                        tabIndex="-1"
                        value={(Math.round(volume * 100) / 100 || 0) + ' м³'}
                        readOnly={true} />
                </div>
            )
        } else {
            volumeControl = (
                <div className="DimensionsControl-volume">
                    <InputControl
                        className={{ '-error': attributes.volume.error }}
                        label="Объём"
                        labelSize="small"
                        id={this._volumeFieldName}
                        type="text"
                        pattern="(\d+.?\d*)"
                        placeholder={dimensionPlaceholder + "³"}
                        value={volume.toString()}
                        onChange={this._onValueChange.bind(this, 'volume')} />

                </div>
            );
        }

        return (
            <div className="DimensionsControl">
                <div className="DimensionsControl-row">
                    {unitOfMeasurement}
                    {dimensions}
                    {equally}
                    {volumeControl}
                    {weight}
                </div>
                <div className="DimensionsControl-image" />
            </div>
        );
    }
}

export default DimensionsControl;



// WEBPACK FOOTER //
// ./client/components/DimensionsControl/DimensionsControl.js